// extracted by mini-css-extract-plugin
export default {"tabs":"finance_financial-details-panel_tabs","tabHeader":"finance_financial-details-panel_tabHeader","floatRight":"finance_financial-details-panel_floatRight"};